import { DateFilter, DateFilterLabel } from 'types/chart';
import { SelectOption } from 'types/common';

export const QUOTE_CHART_DATE_BUTTONS_FILTER: SelectOption<
  DateFilter,
  DateFilterLabel
>[] = [
  {
    value: 'ONE_MONTH',
    label: '최근 한 달',
  },
  {
    value: 'THREE_MONTH',
    label: '3개월',
  },
];

export const QUOTE_CHART_DATE_SELECT_FILTER: SelectOption<
  DateFilter,
  DateFilterLabel
>[] = [
  {
    value: 'ONE_MONTH',
    label: '최근 한 달',
  },
  {
    value: 'THREE_MONTH',
    label: '3개월',
  },
  {
    value: 'SIX_MONTH',
    label: '6개월',
  },
  {
    value: 'ONE_YEAR',
    label: '1년',
  },
  {
    value: 'THREE_YEAR',
    label: '3년',
  },
];
